import { FC } from 'react';

import { defectIsBinnenPeriodeNietInzetbaar } from '@/domain/defecten/defect';
import { Defect } from '@/types/Defecten';

import { Reserve } from '../../types';
import { isNietInzetbaarReserve } from '../../utils/reserve';
import DefectIcon from '../defect/DefectIcon';
import SidepanelToggle from '../Sidepanel/Toggle/SidepanelToggle';

type ReserveDefectIconProps = {
  reserve: Reserve;
  relatedDefect?: Defect | null;
  metSidepanelToggle?: boolean;
};

/** Renders the defect icon belonging to a reserve, if any. A reserve that is currently not
 * inzetbaar (AANKOMEND/ACHTERSTALLIG, see reserves v2) always shows the "niet inzetbaar" status
 * icon, regardless of the related defect's own soort. Otherwise the related defect's own icon is
 * shown, if there is one.
 *
 * @param props
 * @returns
 */
const ReserveDefectIcon: FC<ReserveDefectIconProps> = ({
  reserve,
  relatedDefect = undefined,
  metSidepanelToggle = false,
}) => {
  if (isNietInzetbaarReserve(reserve)) {
    const statusDefectIcon = <DefectIcon defectSoort='DEFECT_NIET_INZETBAAR' />;
    return metSidepanelToggle && relatedDefect ? (
      <SidepanelToggle activeStyle={false} eenheid={String(relatedDefect.eenheidNummer)} defect={relatedDefect}>
        {statusDefectIcon}
      </SidepanelToggle>
    ) : (
      statusDefectIcon
    );
  }

  if (!relatedDefect) return null;

  const defectIcon = (
    <DefectIcon
      defectSoort={relatedDefect.soort}
      nietInzetbaarBinnen24Uur={defectIsBinnenPeriodeNietInzetbaar(relatedDefect)}
    />
  );

  return metSidepanelToggle ? (
    <SidepanelToggle activeStyle={false} eenheid={String(relatedDefect.eenheidNummer)} defect={relatedDefect}>
      {defectIcon}
    </SidepanelToggle>
  ) : (
    defectIcon
  );
};
export default ReserveDefectIcon;
